import { render, staticRenderFns } from "./matchPurchaseContract.vue?vue&type=template&id=70134861"
import script from "./matchPurchaseContract.vue?vue&type=script&lang=js"
export * from "./matchPurchaseContract.vue?vue&type=script&lang=js"
import style0 from "./matchPurchaseContract.vue?vue&type=style&index=0&id=70134861&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports